// Image import compression policy. Fork-only.
//
// The import dialog compresses oversized images before adding them to the
// scene. This file holds the limits and ladders that drive that compression.

import { DEFAULT_IMAGE_OPTIONS } from "@excalidraw/common";

// Must stay at or below upstream's own 4 MiB limit (FILE_UPLOAD_MAX_BYTES in
// excalidraw-app/app_constants.ts), otherwise the guard would never fire.
// Deliberately a constant: the user decided this is not something people
// configure.
export const IMAGE_IMPORT_MAX_BYTES = 2 * 1024 * 1024;

export const COMPRESSION_FORMATS = ["image/webp", "image/jpeg"] as const;

export const COMPRESSION_QUALITY_LADDER = [0.85, 0.7, 0.55, 0.4];

export const COMPRESSION_SCALE_LADDER = [1, 0.75, 0.5];

// Mirrors upstream's own resize limit (DEFAULT_IMAGE_OPTIONS.maxWidthOrHeight).
// `imageOptions` is a partial type upstream, so fall back to its own default.
export const MAX_DIMENSION = DEFAULT_IMAGE_OPTIONS?.maxWidthOrHeight ?? 1440;
